module.exports = __webpack_public_path__ + "img/slogan.23ad45e7.webp";